/**
 * Widget for creating column layouts
 * 
 * Usage:
 *   $('#container').cols({ cols: ['.first-left, .second-left', '.first-right, .second-right'] });
 */
(function($) {
	$.widget('ui.cols', {
		
		options: {
			cols: [],
			template: '<div class="col"></div>',
			otherElements: 'after' // where to put the non-columnized content, before of after the columns
		},
		
		_create: function() {
			this._createCols();
		},
		
		_createCols: function(){
			var self = this;
			var isFirst = true;
			var lastAddedCol = null;
			for(var i in self.options.cols){
				var contentsSelector = self.options.cols[i];
				var col = $(self.options.template);
				col.addClass('col-'+i);
				if(isFirst){
					if(self.options.otherElements == 'before'){
						self.element.append(col);
					}else{
						self.element.prepend(col);
					}
				}else{
					lastAddedCol.after(col);
				}
				lastAddedCol = col;
				col.append(self.element.find(contentsSelector));
				isFirst = false;
			}
		}

	});
})(jQuery);